'use strict';

var zabbixUtil = require('../pages/alarm/zabbix-util');

module.exports = /*@ngInject*/ ["ProjectService", "ConfigurationStoreService", function TrainFilterFactory(ProjectService, ConfigurationStoreService) {
    var factory = {
        setFilteredTrains: setFilteredTrains,
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        getColor: getColor,
        getColorStyle: getColorStyle
    };

    var filteredTrains = [];

    var subMap = new Map();

    return factory;

    /*
     FUNCTIONS
     */

    function setFilteredTrains(fTrains) {
        filteredTrains = fTrains;
        notifySubscribers();
    }

    function notifySubscribers() {
        subMap.forEach(function (value, key) {
            value(filteredTrains);
        });
    }

    function subscribe(name, callback) {
        subMap.set(name, callback);
        callback(filteredTrains);
    }

    function unsubscribe(name) {
        subMap.delete(name);
    }

    /**
     * Define top level color of train (map | tile | table )
     * @param options
     * @returns color
     */
    function getColorStyle(options) {
        var fontColor = 'black';
        var level = options.severity;

        var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());
        var obisEnabled = (projectConfiguration && projectConfiguration.dashboardConfiguration) ? (projectConfiguration.dashboardConfiguration.dashboardHideObis !== undefined ? !projectConfiguration.dashboardConfiguration.dashboardHideObis : false) : false;

        var color = 0;
        if (obisEnabled) {
            color = zabbixUtil.getAlarmAckColor(level, options.issues);
        } else {
            var time = (new Date().getTime() - options.lastSeen) / 1000;

            if (time > 600) {
                level = -1;
            }

            //48hours.
            if (time > (48 * 3600)) {
                level = 6;
                fontColor = 'white';
            }

            color = zabbixUtil.getAlarmAckColor(level, options.issues);
        }

        return {'background-color': color, 'color': fontColor};
    }

    function getColor(options) {
        return getColorStyle(options)['background-color'];
    }
}];